var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 662.34,
    height: 501.431,
    viewBox: "0 0 662.34 501.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24748a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24748a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x2: 0.371,
    y2: 1.344,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_505",
    "data-name": "Grupo 505",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_358",
    "data-name": "Trazado 358",
    d: "M668.115,130.865c5.681,12.125-6.357,15.56-20.148,22.059s-24.11,13.6-29.791,1.476-10.291-36.191,9.218-45.385C647.575,99.5,662.434,118.74,668.115,130.865Z",
    transform: "translate(-286.43 -106.46)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_7",
    "data-name": "Elipse 7",
    cx: 18.566,
    cy: 18.619,
    rx: 18.566,
    ry: 18.619,
    transform: "matrix(1, 0.017, -0.017, 1, 335.311, 10.69)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_359",
    "data-name": "Trazado 359",
    d: "M749.015,246.677c-.643-.841-1.285-1.668-1.935-2.471q-1.258-1.569-2.532-3.04c-9.622-11.136-19.856-18.148-31.126-18.9h-.015l-.167-.015-22.456,21.953-7.634,7.459.166.409,4.119,10.287h72.177a178.054,178.054,0,0,0-10.6-15.684Z",
    transform: "translate(-303.493 -134.476)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_360",
    "data-name": "Trazado 360",
    d: "M621.3,145.956h0l6.646-3.132-.926-9.615,4.444,7.957,3.176-1.5-.54-5.608,2.592,4.641,23.6-11.123h0a19.628,19.628,0,0,0-26.144-9.456l-3.42,1.612A19.734,19.734,0,0,0,621.3,145.956Z",
    transform: "translate(-287.936 -108.829)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_361",
    "data-name": "Trazado 361",
    d: "M696.156,519.787H308.523a12.5,12.5,0,0,1-12.471-12.508v-233.6a9.16,9.16,0,0,1,9.137-9.164H699.333a9.319,9.319,0,0,1,9.295,9.322V507.279A12.5,12.5,0,0,1,696.156,519.787Z",
    transform: "translate(-208.986 -144.702)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_362",
    "data-name": "Trazado 362",
    d: "M324.646,513.737H688.091a12.111,12.111,0,0,0,12.094-12.129V303.342a12.111,12.111,0,0,0-12.094-12.129H324.646a12.111,12.111,0,0,0-12.094,12.129V501.609A12.111,12.111,0,0,0,324.646,513.737Z",
    transform: "translate(-213.015 -151.161)",
    fill: "rgba(255,255,255,0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_363",
    "data-name": "Trazado 363",
    d: "M708.4,269.626H295.82v-6.368a12.546,12.546,0,0,1,12.517-12.546H695.88A12.545,12.545,0,0,1,708.4,263.258Z",
    transform: "translate(-208.93 -141.362)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_8",
    "data-name": "Elipse 8",
    cx: 3.238,
    cy: 3.247,
    rx: 3.238,
    ry: 3.247,
    transform: "translate(106.4 115.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_9",
    "data-name": "Elipse 9",
    cx: 3.238,
    cy: 3.247,
    rx: 3.238,
    ry: 3.247,
    transform: "translate(118.69 115.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_10",
    "data-name": "Elipse 10",
    cx: 3.238,
    cy: 3.247,
    rx: 3.238,
    ry: 3.247,
    transform: "translate(130.979 115.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_364",
    "data-name": "Trazado 364",
    d: "M571.157,513.039h-32.5a7.2,7.2,0,0,1-7.181-7.2v-32.6a7.2,7.2,0,0,1,7.181-7.2h32.5a7.2,7.2,0,0,1,7.18,7.2v32.6A7.2,7.2,0,0,1,571.157,513.039Zm-32.5-45.483a5.684,5.684,0,0,0-5.669,5.686v32.6a5.684,5.684,0,0,0,5.669,5.685h32.5a5.683,5.683,0,0,0,5.669-5.685v-32.6a5.683,5.683,0,0,0-5.669-5.686Z",
    transform: "translate(-266.463 -193.46)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_365",
    "data-name": "Trazado 365",
    d: "M568.394,506.846H548.741a2.273,2.273,0,0,1-2.268-2.274V480.314a2.273,2.273,0,0,1,2.268-2.274h14.24a2.271,2.271,0,0,1,1.421.5l5.412,4.362a2.264,2.264,0,0,1,.847,1.773v19.9A2.273,2.273,0,0,1,568.394,506.846Zm-19.652-27.29a.759.759,0,0,0-.756.758v24.258a.758.758,0,0,0,.756.758h19.652a.758.758,0,0,0,.756-.758v-19.9a.754.754,0,0,0-.282-.591l-5.413-4.362a.756.756,0,0,0-.473-.167Z",
    transform: "translate(-270.125 -196.363)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_366",
    "data-name": "Trazado 366",
    d: "M566.323,491.556H554.23a.758.758,0,0,1,0-1.516h12.093a.758.758,0,0,1,0,1.516Z",
    transform: "translate(-271.834 -199.267)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_367",
    "data-name": "Trazado 367",
    d: "M566.323,497.556H554.23a.758.758,0,0,1,0-1.516h12.093a.758.758,0,0,1,0,1.516Z",
    transform: "translate(-271.834 -200.718)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_368",
    "data-name": "Trazado 368",
    d: "M566.323,503.556H554.23a.758.758,0,0,1,0-1.516h12.093a.758.758,0,0,1,0,1.516Z",
    transform: "translate(-271.834 -202.17)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_369",
    "data-name": "Trazado 369",
    d: "M673.156,513.039h-32.5a7.2,7.2,0,0,1-7.181-7.2v-32.6a7.2,7.2,0,0,1,7.181-7.2h32.5a7.2,7.2,0,0,1,7.181,7.2v32.6A7.2,7.2,0,0,1,673.156,513.039Zm-32.5-45.483a5.684,5.684,0,0,0-5.669,5.686v32.6a5.684,5.684,0,0,0,5.669,5.685h32.5a5.684,5.684,0,0,0,5.669-5.685v-32.6a5.684,5.684,0,0,0-5.669-5.686Z",
    transform: "translate(-291.366 -193.46)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_370",
    "data-name": "Trazado 370",
    d: "M670.905,502.717H649.742a2.273,2.273,0,0,1-2.268-2.274V488.314a2.273,2.273,0,0,1,2.268-2.274h21.164a2.274,2.274,0,0,1,2.268,2.274v12.129A2.274,2.274,0,0,1,670.905,502.717Zm-21.164-15.161a.758.758,0,0,0-.756.758v12.129a.757.757,0,0,0,.756.758h21.164a.758.758,0,0,0,.756-.758V488.314a.758.758,0,0,0-.756-.758Z",
    transform: "translate(-294.783 -198.299)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_371",
    "data-name": "Trazado 371",
    d: "M660.323,496.862a2.266,2.266,0,0,1-1.2-.343l-11.293-7.078a.758.758,0,0,1,.8-1.286l11.293,7.078a.758.758,0,0,0,.8,0l11.292-7.078a.758.758,0,0,1,.8,1.286l-11.292,7.078A2.265,2.265,0,0,1,660.323,496.862Z",
    transform: "translate(-294.783 -198.783)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_372",
    "data-name": "Trazado 372",
    d: "M469.156,513.039h-32.5a7.2,7.2,0,0,1-7.181-7.2v-32.6a7.2,7.2,0,0,1,7.181-7.2h32.5a7.2,7.2,0,0,1,7.181,7.2v32.6A7.2,7.2,0,0,1,469.156,513.039Zm-32.5-45.483a5.684,5.684,0,0,0-5.669,5.686v32.6a5.683,5.683,0,0,0,5.669,5.685h32.5a5.683,5.683,0,0,0,5.669-5.685v-32.6a5.684,5.684,0,0,0-5.669-5.686Z",
    transform: "translate(-241.56 -193.46)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_373",
    "data-name": "Trazado 373",
    d: "M466.905,502.717H445.742a2.273,2.273,0,0,1-2.268-2.274V488.314a2.273,2.273,0,0,1,2.268-2.274h21.164a2.273,2.273,0,0,1,2.268,2.274v12.129A2.273,2.273,0,0,1,466.905,502.717Zm-21.164-15.161a.758.758,0,0,0-.756.758v12.129a.758.758,0,0,0,.756.758h21.164a.758.758,0,0,0,.756-.758V488.314a.758.758,0,0,0-.756-.758Z",
    transform: "translate(-244.978 -198.299)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_374",
    "data-name": "Trazado 374",
    d: "M464.634,504.532H449.424a1.516,1.516,0,0,1-1.309-2.274l4.582-7.96a1.51,1.51,0,0,1,2.619,0l2.959,5.14,1.714-2.978a1.51,1.51,0,0,1,2.619,0l3.337,5.8a1.516,1.516,0,0,1-1.31,2.274Zm0-1.516h0l-3.337-5.8-2.369,4.115a.756.756,0,0,1-.655.379h0a.756.756,0,0,1-.655-.379l-3.614-6.278-4.582,7.96Z",
    transform: "translate(-246.062 -200.114)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 1.512,
    cy: 1.516,
    rx: 1.512,
    ry: 1.516,
    transform: "translate(218.148 290.772)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_375",
    "data-name": "Trazado 375",
    d: "M764.408,636.708h-9.267l-4.408-35.847h13.676Z",
    transform: "translate(-183.286 -145.377)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_376",
    "data-name": "Trazado 376",
    d: "M943.165,762.65H913.286v-.379a11.647,11.647,0,0,1,11.63-11.664h18.25Z",
    transform: "translate(-359.68 -262.31)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_377",
    "data-name": "Trazado 377",
    d: "M814.408,636.708h-9.267l-4.408-35.847H814.41Z",
    transform: "translate(-195.493 -145.377)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    "data-name": "Trazado 378",
    d: "M993.169,762.65H963.289v-.379a11.647,11.647,0,0,1,11.63-11.664h18.25Z",
    transform: "translate(-371.887 -262.31)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    "data-name": "Trazado 379",
    d: "M979.592,690.135l-8.583-2.618a3.4,3.4,0,0,1-2.393-2.906l-8-76.053a.363.363,0,0,0-.361-.339.355.355,0,0,0-.386.31l-13.4,73.682a3.4,3.4,0,0,1-4.032,2.729l-10.968-2.265a3.422,3.422,0,0,1-2.707-3.572l8.152-120.767,55.282-5.982-8.214,134.726a3.4,3.4,0,0,1-4.385,3.056Z",
    transform: "translate(-363.455 -214.343)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_12",
    "data-name": "Elipse 12",
    cx: 18.565,
    cy: 18.619,
    rx: 18.565,
    ry: 18.619,
    transform: "translate(597.52 201.586)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M998.878,567.657a7.636,7.636,0,0,0,1.32-11.613l12.393-24.069-13.957,1.494L989.006,556.1a7.655,7.655,0,0,0,9.872,11.561Z",
    transform: "translate(-377.672 -209.413)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    "data-name": "Trazado 383",
    d: "M854.46,380.659a7.6,7.6,0,0,0,10.148,5.747l17.268,20.83,4.07-13.472-17.022-17.715a7.642,7.642,0,0,0-14.465,4.61Z",
    transform: "translate(-345.284 -170.598)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_507",
    "data-name": "Grupo 507",
    transform: "translate(522.219 214.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    "data-name": "Trazado 380",
    d: "M939.433,529.3l11.986-75.692A28.615,28.615,0,0,1,987.7,430.562h0a28.616,28.616,0,0,1,20.107,32.795l-12.541,67.6Z",
    transform: "translate(-888.282 -398.975)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    "data-name": "Trazado 382",
    d: "M1003.764,530.791a3.4,3.4,0,0,1-1.834-.873l-4.742-4.394a3.428,3.428,0,0,1-.825-3.831l9.476-22.528-1.344-44.513a10.958,10.958,0,1,1,21.713,2.97l2.3,27.982a35.227,35.227,0,0,1-6.756,23.8l-14.779,20.037a3.4,3.4,0,0,1-2.415,1.368A3.369,3.369,0,0,1,1003.764,530.791Z",
    transform: "translate(-902.115 -402.78)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M872.244,393.577a3.411,3.411,0,0,1,1.516-1.354l5.884-2.666a3.405,3.405,0,0,1,3.84.732l16.99,17.535,41.4,16.113a10.981,10.981,0,0,1-11.193,18.9l-26.589-8.787a35.07,35.07,0,0,1-19.219-15.519l-12.636-21.461a3.417,3.417,0,0,1,.013-3.489Z",
    transform: "translate(-871.76 -389.257)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    "data-name": "Trazado 385",
    d: "M830.26,375.652,829.5,399.91,815.58,424.176l11.627-27.042Z",
    transform: "translate(-199.118 -90.888)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_386",
    "data-name": "Trazado 386",
    d: "M986.046,393.083a4.855,4.855,0,0,1-5.314-3.565,7.393,7.393,0,0,0-5.254-5.514c-3.406-.78-7.568.827-10.064-1.76a5.043,5.043,0,0,1-1.191-4.429c.46-2.515,2.253-4.414,4.2-5.934a25.7,25.7,0,0,1,14.26-5.345,51.045,51.045,0,0,1,8.028.4,35.443,35.443,0,0,1,8.211,1.505,19.372,19.372,0,0,1,12.1,14.161,22.432,22.432,0,0,1-4.579,18.292,23.966,23.966,0,0,1-9.191,7.019,3.577,3.577,0,0,1-2.726.139c-2.235-.891-1.87-3.668-.851-5.52,1.091-1.982,2.769-3.9,1.892-6.314a4.771,4.771,0,0,0-2.364-2.552c-2.222-1.137-4.707-.868-7.1-.591Z",
    transform: "translate(-372.089 -169.38)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    "data-name": "Trazado 387",
    d: "M768.049,391.722H538.268A12.5,12.5,0,0,1,525.8,379.214V329.941a12.5,12.5,0,0,1,12.471-12.508H768.049a12.5,12.5,0,0,1,12.472,12.508v49.273A12.5,12.5,0,0,1,768.049,391.722Z",
    transform: "translate(-265.077 -157.505)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    "data-name": "Trazado 388",
    d: "M767.927,391.98H538.146a12.883,12.883,0,0,1-12.85-12.887V329.82a12.883,12.883,0,0,1,12.85-12.887h229.78a12.883,12.883,0,0,1,12.85,12.887v49.274A12.883,12.883,0,0,1,767.927,391.98Zm-229.78-73.531a11.367,11.367,0,0,0-11.338,11.371v49.274a11.367,11.367,0,0,0,11.338,11.371h229.78a11.367,11.367,0,0,0,11.338-11.371V329.82a11.367,11.367,0,0,0-11.338-11.371Z",
    transform: "translate(-264.955 -157.384)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    "data-name": "Trazado 389",
    d: "M749.115,383.222H575.268A12.5,12.5,0,0,1,562.8,370.715V344.941a12.5,12.5,0,0,1,12.471-12.508H749.115a12.5,12.5,0,0,1,12.472,12.508v25.774a12.5,12.5,0,0,1-12.472,12.508Z",
    transform: "translate(-274.11 -161.134)",
    fill: "rgba(242,242,242,0.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_13",
    "data-name": "Elipse 13",
    cx: 14.915,
    cy: 14.958,
    rx: 14.915,
    ry: 14.958,
    transform: "translate(323.655 178.282)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_390",
    "data-name": "Trazado 390",
    d: "M745.743,384.719,724.69,367.011,704,349.609a3.017,3.017,0,0,0-3.895.007L679.484,367.1l-5.037,4.27-7.595-6.388-23.082-19.414a3.017,3.017,0,0,0-3.895.008l-23.007,19.5L593.5,384.888a.758.758,0,0,0,.489,1.337l47.911-.093,15.166-.029-.148.126,45.206-.087,43.134-.083a.758.758,0,0,0,.484-1.339Z",
    transform: "translate(-281.541 -164.14)",
    fill: "#519390"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_391",
    "data-name": "Trazado 391",
    d: "M1009.02,767.449H863.9a.758.758,0,0,1,0-1.516H1009.02a.758.758,0,0,1,0,1.516Z",
    transform: "translate(-347.437 -266.019)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    d: "M760.348,219.944a8.481,8.481,0,0,0-5.48-3.866,7.774,7.774,0,0,0-1.254-.159L696.025,164.28a6.806,6.806,0,0,0-4.256-2.039,5.774,5.774,0,0,0-.96-.03,6.867,6.867,0,0,0-4.5,11.735l22.048,19.277,36.206,31.649a9.045,9.045,0,0,0,.265,1.766,8.524,8.524,0,0,0,7.309,6.345,8.363,8.363,0,0,0,4.573-.758,8.626,8.626,0,0,0,2.933-2.251c.083-.1.159-.19.234-.3a8.581,8.581,0,0,0,.476-9.733Z",
    transform: "translate(-303.768 -119.947)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_393",
    "data-name": "Trazado 393",
    d: "M649.571,277.3l-.536-21.877-.454-18.155-.31-12.7-.612-24.766a6.833,6.833,0,0,0-11.874-3.98,5.224,5.224,0,0,0-.567.728,6.79,6.79,0,0,0-1.179,4.586l1.346,36.136.673,18.155.861,23.159a9.168,9.168,0,0,0-.672,1.069,8.547,8.547,0,1,0,13.326-2.35Z",
    transform: "translate(-291.494 -127.535)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_394",
    "data-name": "Trazado 394",
    d: "M701.651,207.585l-5.344-14.517-8.647-23.515a12.115,12.115,0,0,0-7.521-7.338c-.136-.046-.28-.091-.415-.129a12.052,12.052,0,0,0-10.007,1.38l-29.123,18.527a12.22,12.22,0,0,0-3.983,16.488,209.5,209.5,0,0,0,11.89,18.337c3.394,4.632,9.713,5.124,10.809,12.7h21.473L702.52,209.95Z",
    transform: "translate(-291.721 -119.793)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_14",
    "data-name": "Elipse 14",
    cx: 17.514,
    cy: 17.565,
    rx: 17.514,
    ry: 17.565,
    transform: "translate(58.952 230.076)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    d: "M324.9,416.649q.259.206.5.438a7.884,7.884,0,0,1-.315,11.737,7.357,7.357,0,0,1-.615.465l1.185,40.135a6.109,6.109,0,0,1-4.191,5.963l-.072.016-32.493,3.47a6.745,6.745,0,0,1-1.3-13.428l23.163-2.046,4.006-34.757a7.492,7.492,0,0,1-.734-.75A7.858,7.858,0,0,1,324.9,416.649Z",
    transform: "translate(-205.44 -181.098)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_396",
    "data-name": "Trazado 396",
    d: "M139.328,638.38h8.743l4.159-33.819h-12.9Z",
    transform: "translate(-34.015 -146.272)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_397",
    "data-name": "Trazado 397",
    d: "M317.242,751.858H334.46a10.988,10.988,0,0,1,10.972,11v.357H317.242Z",
    transform: "translate(-214.16 -262.613)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_398",
    "data-name": "Trazado 398",
    d: "M24.366,623.907l7.512,4.486L52.7,601.469l-11.087-6.62Z",
    transform: "translate(-5.949 -143.922)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_399",
    "data-name": "Trazado 399",
    d: "M202.755,734.889l14.793,8.833h0a11.022,11.022,0,0,1,3.814,15.084l-.182.308L196.96,744.651Z",
    transform: "translate(-184.794 -258.507)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    "data-name": "Trazado 400",
    d: "M304.529,688.408h-9.79a3.206,3.206,0,0,1-3.191-2.878l-9.869-93.041a1.069,1.069,0,0,0-2.039-.328l-17.8,39.539-31.522,51.549a3.219,3.219,0,0,1-4.028,1.263l-12.593-5.557a3.224,3.224,0,0,1-1.462-4.6L241.209,625.7l8.887-41c-2.8-17.78,9.187-44.214,9.309-44.48l.059-.129,33.006-12.938.166.2c13.017,42.84,20.948,88.944,15.092,158.105a3.235,3.235,0,0,1-3.2,2.948Z",
    transform: "translate(-188.411 -208.246)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_401",
    "data-name": "Trazado 401",
    d: "M268.416,529.179l-.154-.324c-.074-.155-7.413-15.679-13.07-32.271a24.586,24.586,0,0,1,17.423-31.745h0a24.683,24.683,0,0,1,28.668,14.835c4.488,11.255,3.057,23.268,1.711,32.715l-.027.189-.172.082Z",
    transform: "translate(-198.694 -193.003)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_402",
    "data-name": "Trazado 402",
    d: "M301.141,415.326H273.33V403.167c6.1-2.432,12.077-4.5,15.688,0a12.14,12.14,0,0,1,12.123,12.158Z",
    transform: "translate(-203.439 -177.606)",
    fill: "#519390"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_403",
    "data-name": "Trazado 403",
    d: "M264.42,401.185c-16.626,0-21.279,20.9-21.279,32.691,0,6.576,2.965,8.928,7.625,9.723l1.646-8.8,3.854,9.18c1.309.007,2.684-.019,4.109-.045l1.307-2.7,2.914,2.65c11.671.018,21.1,1.724,21.1-10.008C285.7,422.085,281.618,401.185,264.42,401.185Z",
    transform: "translate(-196.068 -177.769)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_404",
    "data-name": "Trazado 404",
    d: "M326.744,767.449H181.62a.758.758,0,0,1,0-1.516H326.744a.758.758,0,0,1,0,1.516Z",
    transform: "translate(-180.864 -266.019)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_405",
    "data-name": "Trazado 405",
    d: "M364.656,423.932h-32.5a7.2,7.2,0,0,1-7.181-7.2v-32.6a7.2,7.2,0,0,1,7.181-7.2h32.5a7.2,7.2,0,0,1,7.181,7.2v32.6A7.2,7.2,0,0,1,364.656,423.932Z",
    transform: "translate(-216.047 -171.901)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_406",
    "data-name": "Trazado 406",
    d: "M364.656,423.932h-32.5a7.2,7.2,0,0,1-7.181-7.2v-32.6a7.2,7.2,0,0,1,7.181-7.2h32.5a7.2,7.2,0,0,1,7.181,7.2v32.6A7.2,7.2,0,0,1,364.656,423.932Zm-32.5-45.483a5.683,5.683,0,0,0-5.669,5.685v32.6a5.684,5.684,0,0,0,5.669,5.685h32.5a5.684,5.684,0,0,0,5.669-5.685v-32.6a5.683,5.683,0,0,0-5.669-5.685Z",
    transform: "translate(-216.047 -171.901)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_407",
    "data-name": "Trazado 407",
    d: "M362.405,414.9H341.241a2.274,2.274,0,0,1-2.268-2.274V396.707a2.273,2.273,0,0,1,2.268-2.274H347.2a2.252,2.252,0,0,1,1.931,1.082l1.661,2.708h11.613a2.273,2.273,0,0,1,2.268,2.274v12.129A2.273,2.273,0,0,1,362.405,414.9Z",
    transform: "translate(-219.465 -176.135)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_408",
    "data-name": "Trazado 408",
    d: "M349.043,430.738q.159.291.293.6a7.875,7.875,0,0,1-4.832,10.695,7.3,7.3,0,0,1-.747.189l-14.436,37.451a6.092,6.092,0,0,1-6.17,3.865l-.073-.014-31.29-9.447a6.744,6.744,0,0,1,4-12.882l22.139,7.129,17.14-30.475a7.474,7.474,0,0,1-.386-.978,7.848,7.848,0,0,1,14.367-6.133Z",
    transform: "translate(-206.79 -183.931)",
    fill: "#faf8f8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductos);
export default __webpack_public_path__ + "static/media/productos.e18f0a08be299d1b962d625bdde8bbaf.svg";
export { ForwardRef as ReactComponent };